<script>
export default {
  name: 'icon-background',
  props: {
    color: {
      type: String,
      default: '#00A5EE',
    },
  },
}
</script>

<template>
  <svg
    width="32"
    height="19"
    viewBox="0 0 32 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6085 0.84184L13.1187 6.8244L16.8216 11.7539C17.3655 12.483 17.215 13.5128 16.4976 14.0567C15.7686 14.6006 14.7387 14.4617 14.1948 13.7327C12.6211 11.6382 10.758 9.16188 9.45043 7.41456C8.61727 6.2921 6.93938 6.30367 6.09464 7.41456L0.424517 14.9824C-0.616935 16.3595 0.378231 18.3382 2.10241 18.3382H29.8976C31.6218 18.3382 32.6169 16.3595 31.5755 14.9824L20.9643 0.84184C20.1195 -0.280613 18.4416 -0.280613 17.6085 0.84184Z"
      :fill="color"
    />
  </svg>
</template>
